import { 
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_DASHBOARD 
}  from "../actions/types";

const initialState = {
  dashboard: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    // ensure no redux values linger between users ----
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
        return {
            ...initialState,
        }
    // ------------------------------------------------
    case GET_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload
      };
    default:
      return state;
  }
}